
export default function initializeWooSliders() {
    initializeThumbnailSlider();
}

function initializeThumbnailSlider() {
    let thumbnailSlider = document.querySelector('.woocommerce-product-thumbnails__swiper');

    if (!thumbnailSlider) {
        return;
    }
    import('swiper/bundle').then(({ default: Swiper }) => {
        const swiper = new Swiper('.woocommerce-product-thumbnails__swiper', {
            loop: false,
            speed: 1200,
            preloadImages: false,
            slidesPerView: "auto",
            spaceBetween: 12,
            navigation: {
                nextEl: thumbnailSlider.querySelector( '.woocommerce-product-thumbnails__arrow--next' ),
                prevEl: thumbnailSlider.querySelector( '.woocommerce-product-thumbnails__arrow--prev' ),
            },
        });
    });


    thumbnailSlider.querySelectorAll('.swiper-slide').forEach(function (element) {
        let slide = element;

        element.addEventListener('click', function () {
            let index = Array.prototype.indexOf.call(slide.parentNode.children, slide);

            document.querySelector('.woocommerce-product-gallery .flex-control-nav').children[index].querySelector('img').click();
        });
    });
}

function fixVariationsInThumbnailSlider(element) {
    let thumbnailsSlider = element.find('.woocommerce-product-thumbnails');

    if (thumbnailsSlider) {
        thumbnailsSlider.find('.woocommerce-product-thumbnails__swiper-slide-inner img').each(function () {
            let mainImage = element.find('.woocommerce-product-gallery__image a[data-o_href="' + jQuery(this).data('src') + '"]');

            if (mainImage.length > 0) {
                console.log(mainImage.parent().data());
                jQuery(this).attr('src', mainImage.parent().data('thumb'));
            }
        })
    }
}

window.fixVariationsInThumbnailSlider = fixVariationsInThumbnailSlider;